import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '@shared/services/notification.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private _notify: NotificationService ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event:any) => { 
                    if(event?.body?.isRefreshNeeded)
                        window.location.reload();
                },
                error => {
                    this._notify.setApiError(error);
                }
              )
        );
    }
}